import React, { useState, useEffect, useRef } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  Label,
} from "reactstrap"
import { useLocation, useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import profile1 from "assets/images/SPS Logo - Golden.png"
import { AuthAPI } from "../../apis/AuthAPI"
import Loading from "components/Loading"

const OtpVerify = () => {
  document.title = "OTP Verification | SOUTH POINT SCHOOL"

  const location = useLocation()
  const navigate = useNavigate()
  const { email, expires_in } = location.state || {}

  const [otp, setOtp] = useState(["", "", "", "", "", ""])
  const [loading, setLoading] = useState(false)
  const [timer, setTimer] = useState(expires_in || 60)
  const [canResend, setCanResend] = useState(false)
  const inputRefs = useRef([])

  const maskEmail = emailStr => {
    if (!emailStr) return ""
    const [name, domain] = emailStr.split("@")
    if (name.length <= 2) return `${name[0]}***@${domain}`
    const visible = Math.ceil(name.length / 2)
    return `${name.slice(0, visible)}${"*".repeat(name.length - visible)}@${domain}`
  }

  useEffect(() => {
    if (!email) {
      navigate("/login")
    } else {
      // Auto-focus the first OTP input on page load
      setTimeout(() => {
        inputRefs.current[0]?.focus()
      }, 100)
    }
  }, [email, navigate])

  useEffect(() => {
    let interval = null
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer(prev => prev - 1)
      }, 1000)
    } else {
      setCanResend(true)
    }
    return () => clearInterval(interval)
  }, [timer])

  const handleChange = (value, index) => {
    if (!/^\d*$/.test(value)) return

    const newOtp = [...otp]
    newOtp[index] = value.slice(-1)
    setOtp(newOtp)

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus()
    }
  }

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus()
    }
  }

  const handlePaste = e => {
    e.preventDefault()
    const pastedData = e.clipboardData.getData("text").trim()
    if (/^\d{6}$/.test(pastedData)) {
      const newOtp = pastedData.split("")
      setOtp(newOtp)
      inputRefs.current[5]?.focus()
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    const otpValue = otp.join("")

    if (otpValue.length !== 6) {
      Swal.fire({
        text: "Please enter a valid 6-digit OTP",
        icon: "warning",
      })
      return
    }

    setLoading(true)
    AuthAPI.otpCheck({ email, otp: otpValue })
      .then(res => {
        if (res.data.status === 200) {
          localStorage.setItem("User", JSON.stringify("Admin"))
          localStorage.setItem(
            "Token",
            JSON.stringify(res.data.payload.token.access)
          )
          localStorage.setItem("access_token", res.data.payload.token.access)
          localStorage.setItem("refresh_token", res.data.payload.token.refresh)
          localStorage.setItem("Admin", JSON.stringify(res.data.payload))
          Swal.fire({
            text: res.data.msg || "Login Successful!",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            window.location.href = "/dashboard"
          })
        } else {
          Swal.fire({
            text: res.data.msg || "Invalid OTP. Please try again.",
            icon: "error",
          })
          setOtp(["", "", "", "", "", ""])
          inputRefs.current[0]?.focus()
        }
        setLoading(false)
      })
      .catch(error => {
        Swal.fire({
          text: error?.response?.data?.msg || "Something went wrong, please try again.",
          icon: "error",
        })
        setLoading(false)
      })
  }

  const handleResendOtp = () => {
    setLoading(true)
    AuthAPI.resentOTP({ email })
      .then(res => {
        if (res.data.status === 200) {
          Swal.fire({
            text: res.data.msg || "OTP resent to your registered email.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          })
          setTimer(res.data.payload?.expires_in || expires_in || 60)
          setCanResend(false)
          setOtp(["", "", "", "", "", ""])
          inputRefs.current[0]?.focus()
        } else {
          Swal.fire({
            text: res.data.msg || "Failed to resend OTP.",
            icon: "error",
          })
        }
        setLoading(false)
      })
      .catch(error => {
        Swal.fire({
          text: error?.response?.data?.msg || "Something went wrong.",
          icon: "error",
        })
        setLoading(false)
      })
  }

  const formatTime = seconds => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`
  }

  return (
    <React.Fragment>
      {loading ? (
        <Loading />
      ) : (
        <div className="account-pages pt-sm-5 bg-image">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5} style={{ marginTop: "20px" }}>
                <h1
                  className="text-center text-danger"
                  style={{ fontWeight: "600", fontSize: "clamp(1.2rem, 4vw, 2.5rem)" }}
                >
                  SOUTH POINT SCHOOL
                </h1>
                <Card className="overflow-hidden">
                  <div className="bg-primary bg-soft">
                    <Row>
                      <Col xs={7}>
                        <div className="text-primary p-4">
                          <h3
                            className="text-primary"
                            style={{ marginTop: "12px" }}
                          >
                            OTP Verification
                          </h3>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img
                          src={profile1}
                          alt=""
                          className="img-fluid"
                          style={{
                            height: "75px",
                            marginRight: "15px",
                            marginTop: "8px",
                            marginBottom: "10px",
                            float: "right",
                          }}
                        />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-4">
                    <div className="p-2">
                      <div className="text-center mb-4">
                        <p className="text-muted">
                          We have sent a 6-digit OTP to your registered email
                        </p>
                        <p className="fw-bold">{maskEmail(email)}</p>
                      </div>

                      <Form onSubmit={handleSubmit}>
                        <Label className="form-label">Enter OTP</Label>
                        <div
                          className="d-flex justify-content-between gap-1 mb-3"
                          onPaste={handlePaste}
                        >
                          {otp.map((digit, index) => (
                            <Input
                              key={index}
                              type="text"
                              inputMode="numeric"
                              maxLength={1}
                              value={digit}
                              innerRef={el => (inputRefs.current[index] = el)}
                              onChange={e => handleChange(e.target.value, index)}
                              onKeyDown={e => handleKeyDown(e, index)}
                              style={{
                                width: "40px",
                                height: "40px",
                                minWidth: "32px",
                                padding: "0",
                                textAlign: "center",
                                fontSize: "18px",
                                fontWeight: "bold",
                                flex: "1",
                                maxWidth: "45px",
                              }}
                            />
                          ))}
                        </div>

                        <div className="text-center mb-3">
                          {!canResend ? (
                            <p className="text-muted">
                              OTP expires in{" "}
                              <span className="text-danger fw-bold">
                                {formatTime(timer)}
                              </span>
                            </p>
                          ) : (
                            <p className="text-danger">OTP has expired</p>
                          )}
                        </div>

                        <div className="mt-3 d-grid">
                          {!canResend ? (
                            <button
                              className="btn btn-primary btn-block"
                              type="submit"
                            >
                              Verify OTP
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-warning btn-block"
                              onClick={handleResendOtp}
                            >
                              Resend OTP
                            </button>
                          )}
                        </div>

                        <hr className="mb-1" />
                        <div className="mt-2 text-center">
                          <button
                            type="button"
                            className="btn btn-link text-muted"
                            onClick={() => navigate("/login")}
                          >
                            <i className="mdi mdi-arrow-left me-1" />
                            Back to Login
                          </button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </React.Fragment>
  )
}

export default OtpVerify
